export function escapeHeaderAttribute(attribute: string) {
  // Allowed value characters: !#$%&'()*+,-./:;<=>?@[]^_`{|}~ and space, a-z, A-Z, 0-9, \, "

  if (!/^[ \w!#$%&'()*+,\-./:;<=>?@[\]^`{|}~"\\]*$/.test(attribute)) {
    throw new Error('Bad attribute value (' + attribute + ')');
  }

  return attribute.replace(/\\/g, '\\\\').replace(/"/g, '\\"'); // Escape quotes and slash
}
